// @owners { team: patient-health }
// eslint-disable-next-line import/no-deprecated
import { deleteTransfer } from '~shared/actions/prescriptions';
import { connect } from '~shared/store';
import { type ReduxDispatchShared } from '~shared/types';
import MedListTransferRow from './MedListTransferRow';

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => ({
  // eslint-disable-next-line import/no-deprecated
  cancelTransfer: (transfer: { id: number }) => dispatch(deleteTransfer(transfer)),
});

export default connect(null, mapDispatchToProps)(MedListTransferRow);
